import 'bootstrap/dist/js/bootstrap.min';
import './assets/fontawesome/css/all.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-medium-image-zoom/dist/styles.css';
import 'swiper/css';
import 'swiper/css/pagination';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

reportWebVitals();
